/**
 * Route for `invoice-crud-permission-scope`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { InvoiceCrudPermissionScopePage } from "../features/invoice-crud-permission-scope/InvoiceCrudPermissionScopePage";

export const invoiceCrudPermissionScopeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/invoice-crud-permission-scope",
	component: InvoiceCrudPermissionScopePage,
});

export default invoiceCrudPermissionScopeRoute;
